/**
 * @generated SignedSource<<621ef6b7c0c7e3ee16dd3cc1b10390b1>>
 * @relayHash efefc67e5d7571d1cce65293772d8405
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a812da40abcb3626d828d15ae1a5306745d8ed6ac3adac701ee223cea5d15eef

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type uiIssueRealtimeUpdatesIssueCreatedSubscription$variables = {
  cloudId: string;
  projectIds?: ReadonlyArray<string> | null | undefined;
};
export type uiIssueRealtimeUpdatesIssueCreatedSubscription$data = {
  readonly jira: {
    readonly onIssueCreatedByProjectsNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type uiIssueRealtimeUpdatesIssueCreatedSubscription = {
  response: uiIssueRealtimeUpdatesIssueCreatedSubscription$data;
  variables: uiIssueRealtimeUpdatesIssueCreatedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIds"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectIds",
            "variableName": "projectIds"
          }
        ],
        "concreteType": "JiraIssueCreatedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueCreatedByProjectsNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "uiIssueRealtimeUpdatesIssueCreatedSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "uiIssueRealtimeUpdatesIssueCreatedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "a812da40abcb3626d828d15ae1a5306745d8ed6ac3adac701ee223cea5d15eef",
    "metadata": {},
    "name": "uiIssueRealtimeUpdatesIssueCreatedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "3f282f9e54a2563a711c161f978a5e67";

export default node;
